<template>
  <div class="w-full flex items-center flex-col justify-center">
    <img
      v-for="(item, index) in list"
      :key="index"
      class="w-full max-h-[100px] object-contain"
      v-lazy="item.logo"
      alt=""
      @click="handelclick(item)"
    />
  </div>
</template>

<script setup>
// import a from '@/assets/images/announcement.png'
const props = defineProps({
  list: {
    type: Array,
    default: () => []
  }
})
const handelclick = (item) => {
  if (item.href) {
    window.open(item.href, '_blank')
  }
}
</script>

<style>
img.van-lazyload {
  object-fit: contain;
  background-color: #f5f5f5; /* 可选: 防止白屏闪烁 */
}
</style>
